var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-inquiry-core',{attrs:{"get-grid-props":_vm.getGridProps}})}
var staticRenderFns = []

export { render, staticRenderFns }